import { render, staticRenderFns } from "./4473SectionE2023.vue?vue&type=template&id=af3ff338"
import script from "./4473SectionE2023.vue?vue&type=script&lang=js"
export * from "./4473SectionE2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports